import s from './Account.module.css';
import {useDispatch, useSelector} from "react-redux";
import del from "../../img/basketDelete.svg";
import {calculateSum, deleteOrder} from "../../store/OrderSlice";
import {deleteLiked} from "../../store/LikedSlice";

const Liked = () => {
    const likedArray = useSelector(state => state.setLiked.liked);
    const dispatch = useDispatch();

    return (
        <div className={s.liked}>
            <h3>Мои Закладки</h3>
            <div className={s.likedItems}>
                <div className={s.title}>
                    <ul>
                        <li>Изображение</li>
                        <li>Наименование товара</li>
                        <li>Наличие</li>
                        <li>Цена</li>
                        <li>Удалить</li>
                    </ul>
                </div>
                <div className={s.likedInfo}>
                    {
                        likedArray.map((el, index) => {
                            return <ul key={index}>
                                <li className={s.likedImg}><img src={el.img} alt=""/></li>
                                <li>{el.name}</li>
                                <li>В наличии</li>
                                <li>{el.price} грн</li>
                                <li><img src={del} alt="" onClick={() => {
                                    dispatch(deleteLiked(index));
                                }
                                }/></li>
                            </ul>
                        })
                    }
                </div>
            </div>
        </div>

    )
}

export default Liked;